<ng-container *ngIf="scenariosTableData?.cells?.length; else riskDataMissing">
	<section class="row padding-top-60">
		<h3 class="col-24 title-main">{{ componentTitle }}</h3>
		<section class="col-24 text-16-bold" dcrHTMLKey="POWERED_BY_ALADDIN">(Powered by Aladdin)</section>
		<section class="col-24 text-16 date" *ngIf="asOfDate"><span dcrHTMLKey="AS_OF_DATE_DYNAMIC" [dcrSubstitutions]="{ $asOfDate$: asOfDate }">As of $asOfDate$</span></section>
		<p class="col-24 disclaimer-container" dcrHTMLKey="RISK_SCENARIO_DISCLAIMER">
			Evaluate your portfolio's sensitivity to different factors and themes. Holdings have been converted to asset classes represented by market indexes, and 12 months of
			income yield are included for fixed income instruments
		</p>
	</section>

	<section class="row row-45">
		<section class="col-10">
			<button dz-button color="secondary" (click)="openScenarioSelectionDialog()" dcrHTMLKey="CHANGE_ADD_SCENARIOS">Change/Add sample scenarios</button>
		</section>
	</section>

	<section class="scenario-table grid margin-bottom-60">
		<!-- Header -->
		<section class="row row-30 text-14-bold col-header-row">
			<span [ngClass]="scenarioNameColumnClass" class="col-header-scenario col-scenario" dcrHTMLKey="SCENARIO_TABLE_HEADER">Scenario</span>
			<section *ngFor="let portfolio of scenariosTableData.headersX" [ngClass]="scenarioValueColumnClass" class="d-flex col-value justify-content-center text-align-center">
				<span>{{ portfolio.formattedValue }}</span>
			</section>
		</section>

		<!-- Main table -->
		<ng-container *ngFor="let header of scenariosTableData.headersY; index as i">
			<section class="row align-items-center" *ngIf="selectedScenarios.includes(header)">
				<section class="col-scenario" [ngClass]="scenarioNameColumnClass">
					<span class="text-16 text-md-14">
						{{ header.formattedValue }}
						<icon *ngIf="header.attribute.infoBubble" type="info-circle" class="info-circle text-14 color-primary" [tooltip]="infoBubble"> </icon>
						<dcr-cell-content [cell]="header"></dcr-cell-content>
						<ng-template #infoBubble> <section [innerHTML]="header.attribute.infoBubble"></section> </ng-template>
					</span>
				</section>
				<section
					[ngClass]="scenarioValueColumnClass"
					class="mobile-bordered padding-vertical-20 text-16 text-md-14 text-sm-12 col-value justify-content-center text-align-center"
					*ngFor="let value of scenariosTableData.cells[i]"
				>
					<span class="text-bold" [class.positive-value]="value.rawValue > 0" [class.negative-value]="value.rawValue <= 0">
						{{ value.formattedValue }}
					</span>
				</section>
			</section>
		</ng-container>
	</section>
</ng-container>

<ng-template #riskDataMissing>
	<section>
		<icon class="warning-icon" type="exclamation-triangle"></icon>
		<span [innerHTML]="'Risk data for your portfolio(s) is missing. Please reload the page.' | dcr: 'RISK_DATA_MISSING'"></span>
	</section>
</ng-template>
